import React, { createContext, useContext } from 'react';
import { useCountries, useGetUserQuery } from '@/hooks/GQL';
import { useLocale } from '@edreamsodigeo/frontend-core';
import { convertPrimeUserToContactDetails } from '@/public/HomePage';

export const SessionContext = createContext(null);

const PFUserInfoContext = createContext(null);

export function UserInfoProvider({ children }) {
  return (
    <PFUserInfoContext.Provider value={useGetUserQuery()}>
      {children}
    </PFUserInfoContext.Provider>
  );
}

export function useUserInfo() {
  return useContext(PFUserInfoContext);
}

export const useContactDetails = () => {
  const { data: userData = null } = useUserInfo() || {};
  const locale = useLocale();
  const { countryData = null } = useCountries({ locale } || {});
  const { getCountries: { countries } = {} } = countryData || {};
  return convertPrimeUserToContactDetails(
    selectPrimeOwner(userData),
    countries
  );
};

export function useUserInfoTravellers() {
  return useContext(PFUserInfoContext)?.data?.getUser?.travellers || [];
}

export function usePrimeOwner() {
  return useUserInfoTravellers().find((traveller) => !!traveller.isPrimeOwner);
}

export function selectPrimeOwner(userData = {}) {
  return (
    userData?.getUser?.travellers?.find(
      (traveller) => !!traveller.isPrimeOwner
    ) || null
  );
}
